import React, { useState } from 'react';
import { Input, Checkbox, Radio, Segment, Button, SegmentSingle, SegmentSingleMob } from '../ui';
import Textarea from '../ui/Textarea';
import classNames from 'classnames';
import axios from 'axios';

const GetPriceing = props => {
  const { className } = props;

  const [values, setValues] = useState({
    voiceover: '',
    budget: '',
    note: '',
    name: '',
    email: '',
    number: '',
    nda: '',
    script: '',
    isBusinessEmail: false,
    'video-type': '',
    'contact-via': '',
    'other-length': '',
    'budget-amount': '',
    'video-length': '',
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const validate = () => {
    const newErrors = {};

    if (!values.name) newErrors.name = 'Your Name is required';
    if (!values.email) newErrors.email = 'Email is required';
    else if (!emailValidation(values.email)) newErrors.email = 'Email is not valid';
    else if (!isEmailBusiness(values.email)) newErrors.email = 'Please enter your Business Email';

    return newErrors;
  };

  const handleChange = e => {
    const { name, value, type, checked } = e.target;
    setLoading(false);
    setErrors({ ...errors, [name]: '' });

    setValues({
      ...values,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const handleVideoTypeChanging = value => {
    setValues({ ...values, 'video-type': value });
  };

  const handleSubmit = e => {
    e.preventDefault();
    setLoading(true);

    const newErrors = validate();

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    const formData = new FormData();

    for (let key in values) {
      if (key === 'nda') {
        formData.append(key, values[key] ? 'Yes' : 'No');
      } else {
        formData.append(key, values[key]);
      }
    }
    formData.append('service', 'Get Pricing');
    formData.append('country', props.country);

    axios.post('https://mailer.weprodigi.com/api/v1/send-business-mail', formData).then(response => {
      if (isEmailBusiness(values.email)) window.location.href = 'https://weprodigi.com/thank-you';
    });
  };

  const emailValidation = email => {
    const regex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if (!email || regex.test(email) === false) {
      return false;
    }
    return true;
  };

  const isEmailBusiness = email => {
    const publicDomains = [
      'gmail.com',
      'yahoo.com',
      'outlook.com',
      'hotmail.com',
      'aol.com',
      'icloud.com',
      'mail.com',
      'mail.ru',
      'zoho.com',
      'yandex.com',
      'yandex.ru',
      'protonmail.com',
    ];

    const domain = email?.split('@')[1];

    if (publicDomains.includes(domain)) {
      return false;
    }
    setValues({ ...values, isBusinessEmail: true });
    return true;
  };

  return (
    <form onSubmit={handleSubmit} className={classNames('flex flex-col gap-[24px]', className)}>
      <div className="flex flex-col gap-[24px]">
        <p className="text-[18px] font-medium leading-[22px] text-black">What is your preferred video style?</p>
        <div className="md:block hidden">
          <SegmentSingle
            options={[
              {
                label: '2D Animation',
                value: '2D Animation',
                content: <video className="object-cover" src="/images/video-production/videos/2d.mp4" muted autoPlay loop playsInline></video>,
              },
              {
                label: '3D Animation',
                value: '3D Animation',
                content: <video className="object-cover" src="/images/video-production/videos/3d.mp4" muted autoPlay loop playsInline></video>,
              },
              {
                label: 'Screencast',
                value: 'Screencast',
                content: (
                  <video className="object-cover" src="/images/video-production/videos/screencast.mp4" muted autoPlay loop playsInline></video>
                ),
              },
              {
                label: 'Typography',
                value: 'Typography',
                content: <video className="object-cover" src="/images/video-production/videos/typogrphy.mp4" muted autoPlay loop playsInline></video>,
              },
              {
                label: 'Mixed Media',
                value: 'Mixed Media',
                content: <video className="object-cover" src="/images/video-production/videos/stock.mp4" muted autoPlay loop playsInline></video>,
              },
              {
                label: '2D Character Animation',
                value: '2D Character Animation',
                content: (
                  <video className="object-cover" src="/images/video-production/videos/2d-character.mp4" muted autoPlay loop playsInline></video>
                ),
              },
              {
                label: '3D Character Animation',
                value: '3D Character Animation',
                content: (
                  <video className="object-cover" src="/images/video-production/videos/3d-character.mp4" muted autoPlay loop playsInline></video>
                ),
              },
              {
                label: 'Whiteboard',
                value: 'Whiteboard',
                content: (
                  <video className="object-cover" src="/images/video-production/videos/whiteboard.mp4" muted autoPlay loop playsInline></video>
                ),
              },
              {
                label: 'Shooting',
                value: 'Shooting',
                content: <video className="object-cover" src="/images/video-production/videos/shooting.mp4" muted autoPlay loop playsInline></video>,
              },
              { label: 'Other', value: 'Other' },
            ]}
            selectedOptions={values['video-type']}
            onChange={handleVideoTypeChanging}
            className="purple_segment"
          />
        </div>
        <div className="md:hidden block">
          <SegmentSingleMob
            options={[
              {
                label: '2D Animation',
                value: '2D Animation',
                content: (
                  <video muted className="object-cover w-full" poster="" loop playsInline>
                    <source src="/images/video-production/videos/2d.mp4" type="video/mp4" />
                    Your browser does not support HTML video
                  </video>
                ),
              },
              {
                label: '3D Animation',
                value: '3D Animation',
                content: (
                  <video muted className="object-cover w-full" poster="" loop playsInline>
                    <source src="/images/video-production/videos/3d.mp4" type="video/mp4" />
                    Your browser does not support HTML video
                  </video>
                ),
              },
              {
                label: 'Screencast',
                value: 'Screencast',
                content: (
                  <video muted className="object-cover w-full" poster="" loop playsInline>
                    <source src="/images/video-production/videos/screencast.mp4" type="video/mp4" />
                    Your browser does not support HTML video
                  </video>
                ),
              },
              {
                label: 'Typography',
                value: 'Typography',
                content: (
                  <video muted className="object-cover w-full" poster="" loop playsInline>
                    <source src="/images/video-production/videos/typogrphy.mp4" type="video/mp4" />
                    Your browser does not support HTML video
                  </video>
                ),
              },
              {
                label: 'Mixed Media',
                value: 'Mixed Media',
                content: (
                  <video muted className="object-cover w-full" poster="" loop playsInline>
                    <source src="/images/video-production/videos/stock.mp4" type="video/mp4" />
                    Your browser does not support HTML video
                  </video>
                ),
              },
              {
                label: '2D Character Animation',
                value: '2D Character Animation',
                content: (
                  <video muted className="object-cover w-full" poster="" loop playsInline>
                    <source src="/images/video-production/videos/2d-character.mp4" type="video/mp4" />
                    Your browser does not support HTML video
                  </video>
                ),
              },
              {
                label: '3D Character Animation',
                value: '3D Character Animation',
                content: (
                  <video muted className="object-cover w-full" poster="" loop playsInline>
                    <source src="/images/video-production/videos/3d-character.mp4" type="video/mp4" />
                    Your browser does not support HTML video
                  </video>
                ),
              },
              {
                label: 'Whiteboard',
                value: 'Whiteboard',
                content: (
                  <video muted className="object-cover w-full" poster="" loop playsInline>
                    <source src="/images/video-production/videos/whiteboard.mp4" type="video/mp4" />
                    Your browser does not support HTML video
                  </video>
                ),
              },
              {
                label: 'Shooting',
                value: 'Shooting',
                content: (
                  <video muted className="object-cover w-full" poster="" loop playsInline>
                    <source src="/images/video-production/videos/shooting.mp4" type="video/mp4" />
                    Your browser does not support HTML video
                  </video>
                ),
              },
              { label: 'Other', value: 'Other' },
            ]}
            selectedOptions={values['video-type']}
            onChange={handleVideoTypeChanging}
            className="purple_segment"
          />
        </div>
      </div>

      <div className="flex flex-col">
        <div className="flex flex-col gap-[24px]">
          <p className="text-[18px] font-[500] leading-[20px] text-black">How long do you believe the video should be?</p>
          <Radio
            name="video-length"
            options={[
              { label: '10 sec', value: '10 sec' },
              { label: '15 sec', value: '15 sec' },
              { label: '30 sec', value: '30 sec' },
              { label: '45 sec', value: '45 sec' },
              { label: '60 sec', value: '60 sec' },
              { label: '90 sec', value: '90 sec' },
              { label: '120 sec', value: '120 sec' },
              { label: '3 min', value: '3 min' },
              { label: '5 min', value: '5 min' },
              { label: 'Other', value: 'Other' },
            ]}
            selectedOption={values['video-length']}
            onChange={handleChange}
            className="grid grid-cols-2"
          />
        </div>
        <div className="w-full flex justify-end">
          {values['video-length'] === 'Other' && (
            <input
              type="text"
              name="other-length"
              value={values['other-length']}
              placeholder="Preefrred duration"
              onChange={handleChange}
              className="w-[260px] py-[10px] pl-[20px] focus:outline-none rounded-[5px] !text-[14px] placeholder-gray-400"
            />
          )}
        </div>
      </div>

      <div className="flex flex-col gap-[24px]">
        <p className="text-[18px] font-[500] leading-[20px] text-black"> Do you need us to write a script?</p>
        <Radio
          name="script"
          options={[
            { label: 'Yes', value: 'Yes' },
            { label: 'My script needs some optimization', value: 'My script needs some optimization' },
            { label: 'No, I already have a script', value: 'No, I already have a script' },
            { label: 'No script required', value: 'No script required' },
          ]}
          selectedOption={values.script}
          onChange={handleChange}
          className="grid grid-cols-1"
        />
      </div>

      <div className="flex flex-col gap-[24px]">
        <p className="text-[18px] font-[500] leading-[20px] text-black"> Do you need a voiceover?</p>
        <Radio
          name="voiceover"
          options={[
            { label: 'Yes', value: 'Yes' },
            { label: 'No', value: 'No' },
          ]}
          selectedOption={values.voiceover}
          onChange={handleChange}
          className="grid grid-cols-1"
        />
      </div>
      <div className="flex flex-col gap-[24px]">
        <p className="text-[18px] font-[500] leading-[20px] text-black"> Do you have a budget in mind?</p>
        <Radio
          name="budget"
          options={[
            {
              label: 'Yes',
              value: 'Yes',
              content: (
                <input
                  type="text"
                  name="budget-amount"
                  placeholder="Budget amount"
                  value={values['budget-amount']}
                  onChange={handleChange}
                  className="py-[10px] pl-[20px] focus:outline-none rounded-[5px] !text-[14px] placeholder-gray-400 w-full"
                />
              ),
            },
            { label: 'No', value: 'No' },
          ]}
          selectedOption={values.budget}
          onChange={handleChange}
          className="grid grid-cols-1"
        />
      </div>

      <div className="flex flex-col gap-[24px]">
        <p className="text-[18px] font-[500] leading-[20px] text-black">Information that you want to share with us</p>
        <Textarea name="note" id="note" placeholder="Main goals, deadlines, etc." value={values.note} onChange={handleChange} />
      </div>

      <div className="flex lg:flex-row flex-col gap-[24px]">
        <div className="w-full lg:w-1/2">
          <Input label="Your Name *" name="name" value={values.name} error={errors.name} onChange={handleChange} />
        </div>
        <div className="w-full lg:w-1/2">
          <Input label="Your Business Email *" name="email" type="email" value={values.email} error={errors.email} onChange={handleChange} />
        </div>
      </div>
      <div className="w-full ">
        <Input label="Your Phone Number" name="number" value={values.number} error={errors.number} onChange={handleChange} />
      </div>

      <div className="flex flex-col gap-[24px]">
        <p className="text-[18px] font-[500] leading-[20px] text-black">What's the best way to contact you?</p>
        <Radio
          name="contact-via"
          options={[
            { label: 'Email', value: 'Email' },
            { label: 'Phone', value: 'Phone' },
            { label: 'Both', value: 'Both' },
          ]}
          selectedOption={values['contact-via']}
          onChange={handleChange}
          className="grid md:grid-cols-3 grid-cols-2"
        />
      </div>

      <div className="w-full  px-3 flex flex-col gap-[10px]">
        <p className="text-[18px] font-[500] leading-[20px] text-black">Is an NDA necessary?</p>
        <Checkbox name="nda" label="Yes" checked={values.nda} error={errors.nda} onChange={handleChange} />
      </div>

      <div className="flex items-center justify-center w-full">
        <Button variant="primary" narrowing="both" mode="light" className="w-full">
          {loading && (
            <svg className="pl" viewBox="0 0 200 200" width="200" height="200" xmlns="http://www.w3.org/2000/svg">
              <defs>
                <linearGradient id="pl-grad1" x1="1" y1="0.5" x2="0" y2="0.5">
                  <stop offset="0%" stopColor="hsl(313,90%,55%)" />
                  <stop offset="100%" stopColor="hsl(223,90%,55%)" />
                </linearGradient>
                <linearGradient id="pl-grad2" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor="hsl(313,90%,55%)" />
                  <stop offset="100%" stopColor="hsl(223,90%,55%)" />
                </linearGradient>
              </defs>
              <circle
                className="pl__ring"
                cx="100"
                cy="100"
                r="82"
                fill="none"
                stroke="url(#pl-grad1)"
                strokeWidth="36"
                strokeDasharray="0 257 1 257"
                strokeDashoffset="0.01"
                strokeLinecap="round"
                transform="rotate(-90,100,100)"
              />
              <line
                className="pl__ball"
                stroke="url(#pl-grad2)"
                x1="100"
                y1="18"
                x2="100.01"
                y2="182"
                strokeWidth="36"
                strokeDasharray="1 165"
                strokeLinecap="round"
              />
            </svg>
          )}
          Get Pricing
        </Button>
      </div>
    </form>
  );
};

export default GetPriceing;
